import React from "react";
import {
  Footer,
  Blog,
  Possibility,
  Features,
  Header,
  WhatsWEBPAGE,
} from "./containers";
import { Navbar, Brands, CTA } from "./components";
import "./App.css";

const App = () => {
  return (
    <div className="App">
      <div className="gradient__bg">
        <Navbar />
        <Header />
      </div>
      <Brands />
      <WhatsWEBPAGE />
      <Features />
      <Possibility />
      <CTA />
      <Blog />
      <Footer />
    </div>
  );
};

export default App;
